// Icons
import { FiX } from "react-icons/fi"

export const CloseButton = ({ onClick }) => (
	<button className="btn btn-ghost btn-sm p-0" onClick={onClick}>
		<FiX size={18} className="text-error" />
	</button>
)